import { useEffect, useMemo } from 'react'
import { Box, Flex } from 'theme-ui'
import { Text } from 'components'

export type Display = {
  title: string | JSX.Element
  display: JSX.Element
  key: string
}

export type TabbedDisplayProps = {
  displays: Display[]
  selectedKey: string
  onSelectionChange: (selectedKey: string) => void
}

export const TabbedDisplay = ({
  displays,
  selectedKey,
  onSelectionChange,
}: TabbedDisplayProps) => {
  const selected = useMemo(
    () => displays.find(({ key }) => key === selectedKey),
    [displays, selectedKey]
  )
  const firstTab = displays[0]
  useEffect(() => {
    if (!selected && firstTab?.key) {
      onSelectionChange(firstTab.key)
    }
  }, [selected, firstTab, onSelectionChange])

  return (
    <>
      {displays.length > 1 && (
        <Flex
          sx={{
            justifyContent: 'center',
            pb: 10,
          }}>
          {displays.map((display) => (
            <Box
              sx={{
                flex: '0 0 auto',
                minWidth: 34,
                textAlign: 'center',
                mx: 30,
                cursor: 'pointer',
              }}
              key={display.key}
              onClick={() => onSelectionChange(display.key)}>
              <Text variant="h3" pb="6px">
                {display.title}
              </Text>
              {display.key === selectedKey && (
                <Box
                  sx={{
                    margin: 'auto',
                    width: 34,
                    height: '4px',
                    bg: 'primary',
                    borderRadius: 10,
                  }}
                />
              )}
            </Box>
          ))}
        </Flex>
      )}
      {selected?.display}
    </>
  )
}
